import { render, staticRenderFns } from "./UserInsurancePolicies.vue?vue&type=template&id=580effc0&scoped=true&"
import script from "./UserInsurancePolicies.vue?vue&type=script&lang=js&"
export * from "./UserInsurancePolicies.vue?vue&type=script&lang=js&"
import style0 from "./UserInsurancePolicies.vue?vue&type=style&index=0&id=580effc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580effc0",
  null
  
)

export default component.exports